import { render, staticRenderFns } from "./IntercomWidget.vue?vue&type=template&id=53b4fc8b&"
import script from "./IntercomWidget.vue?vue&type=script&lang=ts&"
export * from "./IntercomWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src847744399/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b4fc8b')) {
      api.createRecord('53b4fc8b', component.options)
    } else {
      api.reload('53b4fc8b', component.options)
    }
    module.hot.accept("./IntercomWidget.vue?vue&type=template&id=53b4fc8b&", function () {
      api.rerender('53b4fc8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/IntercomWidget.vue"
export default component.exports